export const TESTCASE_STATUS = {
    DRAFT: 'Draft',
    AUTOMATION: 'Automation',
    REVIEW: 'Review',
    APPROVED: 'Approved',
    OBSOLETE: 'Obsolete',
};

export const TESTCASE_SEVERITY = {
    LOW: 'Low',
    MEDIUM: 'Medium',
    HIGH: 'High',
    CRITICAL: 'Critical',
};
